// extracted by mini-css-extract-plugin
module.exports = {"input":"PhoneNumber_input__2QAho","phoneImg":"PhoneNumber_phoneImg__2cwIW"};